import { FC, useId } from "react";

export const SwellIcon: FC<{ className?: string }> = ({ className }) => {
  const id = useId();

  const filterId0 = `swell-icon-filter-0-${id}`;
  const filterId1 = `swell-icon-filter-1-${id}`;
  const filterId2 = `swell-icon-filter-2-${id}`;
  const filterId3 = `swell-icon-filter-3-${id}`;
  const filterId4 = `swell-icon-filter-4-${id}`;
  const filterId5 = `swell-icon-filter-5-${id}`;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        fill="#DBC7BC"
      />
      <g filter={`url(#${filterId0})`}>
        <path
          d="M15.3065 8.00705C15.3065 8.00705 15.3065 9.82632 9.01941 9.82632C4.22715 9.82632 3.09813 8.51392 2.86671 8.11845C2.82496 8.04712 2.81226 7.96525 2.81467 7.88265C2.89115 5.26224 5.36947 2.33008 9.01941 2.33008C12.7272 2.33008 15.3065 5.35596 15.3065 8.00705Z"
          fill="#AFADB2"
        />
      </g>
      <g filter={`url(#${filterId1})`}>
        <path
          d="M2.06675 11.5935C1.73507 10.9459 2.42802 10.4379 3.06987 10.7805C7.94187 13.3813 12.2071 12.4053 16.7004 9.50647C16.7004 9.50647 15.4712 15.5509 8.9422 15.5509C4.85841 15.5509 2.93479 13.2883 2.06675 11.5935Z"
          fill="#ECE6D9"
        />
      </g>
      <g filter={`url(#${filterId2})`}>
        <path
          d="M2.14911 12.9901C3.31765 16.2047 11.6301 18.3665 15.4891 13.514C15.4891 13.514 13.2095 17.1816 8.67807 16.9599C4.14669 16.7381 2.14911 12.9901 2.14911 12.9901Z"
          fill="#CA9D97"
          fill-opacity="0.12"
        />
      </g>
      <g filter={`url(#${filterId3})`}>
        <path
          d="M11.7409 8.72506C11.7651 9.04026 11.5813 9.33359 11.2839 9.44073C9.7558 9.99133 7.68233 9.97613 6.36029 9.24159C6.36029 9.24159 7.04286 5.03049 8.95013 5.03049C10.6942 5.03049 11.5989 6.87879 11.7409 8.72506Z"
          fill="#82837D"
        />
      </g>
      <g filter={`url(#${filterId4})`}>
        <path
          d="M9.0194 2.38492C12.6979 2.38492 15.2517 5.38719 15.2517 8.00702L15.2516 8.00916C15.2515 8.01156 15.2511 8.01563 15.2505 8.02116C15.2492 8.03229 15.2465 8.04956 15.241 8.07202C15.2299 8.11702 15.2072 8.18322 15.1608 8.26389C15.0681 8.42489 14.8791 8.64583 14.4932 8.86916C13.7197 9.31676 12.1595 9.77142 9.0194 9.77142C4.23471 9.77142 3.13082 8.46116 2.91405 8.09076C2.87923 8.03122 2.86728 7.96062 2.86951 7.88422C2.94513 5.29316 5.39945 2.38492 9.0194 2.38492Z"
          stroke="#CA9D97"
          stroke-width="0.164592"
        />
      </g>
      <g filter={`url(#${filterId5})`}>
        <path
          d="M13.8606 4.81784C14.5787 5.88686 13.5383 6.99984 12.2505 6.99984H5.75024C4.46247 6.99984 3.41729 5.88751 4.12539 4.81189C5.03378 3.43202 6.75993 2.33008 8.96439 2.33008C11.172 2.33008 12.9319 3.43519 13.8606 4.81784Z"
          fill="#FFFFFD"
        />
      </g>
      <defs>
        <filter
          id={filterId0}
          x="1.16847"
          y="0.68416"
          width="15.784"
          height="10.7881"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.822959"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
        <filter
          id={filterId1}
          x="0.335039"
          y="7.86055"
          width="18.0113"
          height="9.3363"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.822959"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
        <filter
          id={filterId2}
          x="1.81992"
          y="12.6609"
          width="13.9984"
          height="4.63783"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.164592"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
        <filter
          id={filterId3}
          x="4.87896"
          y="3.54916"
          width="8.34543"
          height="7.75861"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.740663"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
        <filter
          id={filterId4}
          x="1.71711"
          y="1.23277"
          width="14.6867"
          height="9.69081"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.534923"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
        <filter
          id={filterId5}
          x="2.25057"
          y="0.68416"
          width="13.4908"
          height="7.96161"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.822959"
            result="effect1_foregroundBlur_14256_32841"
          />
        </filter>
      </defs>
    </svg>
  );
};
